<template>
  <div class="fklb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;margin-bottom: 20px">
              <el-table-column
                label="头像"
                width="100"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-avatar :size="40" :src="scope.row.headimg"></el-avatar>
                </template>
              </el-table-column>
              <el-table-column
                prop="nickname"
                label="昵称"
                width="100"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                label="真实姓名"
                width="100"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.name!==null&&scope.row.name!==''&&scope.row.name!==undefined">{{scope.row.name}}</span>
                  <span v-else>N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="sex"
                label="性别"
                width="80"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                label="联系电话"
                width="140"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.tel!==null&&scope.row.tel!==''&&scope.row.tel!==undefined">{{scope.row.tel}}</span>
                  <span v-else>N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="地区"
                width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.province!==null&&scope.row.province!==''&&scope.row.province!==undefined">{{scope.row.province}}</span>
                  <span v-if="scope.row.city!==null&&scope.row.city!==''&&scope.row.city!==undefined">{{scope.row.city}}</span>
                  <span v-if="scope.row.county!==null&&scope.row.county!==''&&scope.row.county!==undefined">{{scope.row.county}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="time"
                label="访问时间"
                min-width="200"
                show-overflow-tooltip
              />
              <el-table-column
                prop="shopname"
                label="导购员"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip
              />
              <el-table-column
                label="操作"
                width="280"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-button icon="el-icon-view" size="mini" @click="viewRecord(scope.row)">浏览记录</el-button>
                  <el-button :disabled="scope.row.shopid!==user.userid" icon="el-icon-plus" size="mini" @click="addToClient(scope.row)">添加至客户</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="访客浏览记录"
      :visible.sync="viewVisible"
      width="50%">
      <div v-loading="dloading">
        <el-table
          :data="viewData"
          stripe
          style="width: 100%">
          <el-table-column
            label="类型"
            width="100"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type === 0 ">装修攻略</span>
              <span v-if="scope.row.type === 1 ">晒家</span>
              <span v-if="scope.row.type === 2 ">案例</span>
            </template>
          </el-table-column>
          <el-table-column
            label="封面图"
            width="100"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-image
                :src="scope.row.imgurl"
                fit="cover"
                style="height: 40px;"
                :preview-src-list="[scope.row.imgurl]"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="style"
            label="风格"
            width="100"
            align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            width="200"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="描述"
            min-width="200"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="timeshow"
            label="浏览时间"
            width="200"
            align="center"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title="添加客户"
      :visible.sync="dialogVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="infoForm" :model="infoForm" :rules="infoRules" label-position="right" label-width="75px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="infoForm.name" maxlength="5" />
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input :disabled="isdistel" v-model="infoForm.tel" maxlength="11" minlength="11" />
        </el-form-item>
        <el-form-item label="微信" prop="weixin">
          <el-input v-model="infoForm.weixin" maxlength="20" />
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="infoForm.sex">
            <el-radio :label="2">未知</el-radio>
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否到店" prop="isgoto">
          <el-radio-group v-model="infoForm.isgoto">
            <el-radio :label="0">未到店</el-radio>
            <el-radio :label="1">已到店</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="infoForm.isgoto === 1" label="到店时间" prop="gototime">
          <el-date-picker
            v-model="infoForm.gototime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择到店时间"
          />
        </el-form-item>
        <el-form-item label="地区" prop="city">
          <el-cascader
            v-model="infoForm.city"
            style="width:100%"
            :options="cityoptions"
            filterable
          />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="infoForm.address" type="textarea" maxlength="200" />
        </el-form-item>
        <el-form-item label="意向风格" prop="style">
          <el-select v-model="infoForm.style" filterable clearable>
            <el-option v-for="style in styleList" :key="style.sid" :label="style.name" :value="style.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="房屋面积" prop="area" style="width: 300px;">
          <el-input v-model="infoForm.area">
            <template slot="append">m²</template>
          </el-input>
        </el-form-item>
        <el-form-item label="分组" prop="groupid">
          <el-select v-model="infoForm.groupid" filterable :clearable="true">
            <el-option
              v-for="gitem in groupoptions"
              :key="gitem.value"
              :label="gitem.label"
              :value="gitem.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标签" prop="labels">
          <el-checkbox-group v-model="infoForm.labels" :max="3">
            <el-checkbox v-for="titem in tagaoption" :label="titem.tagid" name="labels">{{ titem.name }}</el-checkbox>
          </el-checkbox-group>
          <el-button size="small" icon="el-icon-edit" type="text" @click="tagsDrawer = true">标签管理...</el-button>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="infoForm.remark" type="textarea" maxlength="200" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subClientInfo()">立即提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-drawer
      title="标签管理"
      :visible.sync="tagsDrawer"
      direction="rtl"
    >
      <div class="tags-container">
        <el-row>
          <div v-for="t in tagaoption" class="tags-item">
            <span>{{ t.name }}</span>
            <el-button v-if="t.userid != 0" type="danger" class="tags-del" icon="el-icon-close" circle @click="delTags(t.tagid)" />
          </div>
          <el-button size="small" icon="el-icon-plus" type="primary" plain @click="addTags">添加</el-button>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getDelVisitorList,
  getBrowsinghistoryList,
  editDelClientInfo,
  getDelClientGroupList,
  getDelClientTagList, editDelClientTag, delDelClientTag
} from '@/api/dealer'
import { validatePhoneNumber } from '@/utils/validate'
import { getCity } from '@/utils/city'
import { getDealerDetail } from '@/api/work'
import { getWxStyleList } from '@/api/pub'
export default {
  name: 'delfklb',
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      searchForm: {
        search: ''
      },
      tagsDrawer: false,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      viewVisible: false,
      dloading: false,
      viewData: [],
      bid: 0,
      cityoptions: getCity(),
      styleList: [],
      groupoptions: [],
      tagaoption: [],
      dialogVisible: false,
      editloading: false,
      isdistel: false,
      infoForm: {
        name: '',
        tel: '',
        weixin: '',
        sex: null,
        city: [],
        address: '',
        style: '',
        area: '',
        labels: [],
        groupid: null,
        remark: '',
        gototime: '',
        isgoto: null
      },
      infoRules: {
        name: [{ required: true, message: '请输入客户真实姓名', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        isgoto: [{ required: true, message: '请选择是否到店', trigger: 'change' }],
        gototime: [{ required: true, message: '请选择到店时间', trigger: 'blur' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getBrandList()
    this.getDelClientGroupList()
    this.getDelClientTagList()
    this.getData()
  },
  methods: {
    getBrandList() {
      getDealerDetail({ delid: this.user.delid }).then(response => {
        if (response.data.brandlst.length > 0) {
          this.bid = response.data.brandlst[0].bid
          this.getStyleList()
        }
      })
    },
    getStyleList() {
      getWxStyleList({}).then(response => {
        let _styleList = []
        for (const s of response.data) {
          if (s.bid === this.bid) {
            _styleList.push(s)
          }
        }
        this.styleList = _styleList
      })
    },
    getDelClientGroupList() {
      getDelClientGroupList({ userid: this.user.userid }).then(response => {
        this.groupOptions = response.data
        const group = []
        for (const g of response.data) {
          if (g.groupid > 3) {
            group.push({ value: g.groupid, label: g.name })
          }
        }
        this.groupoptions = group
      })
    },
    getDelClientTagList() {
      getDelClientTagList({ userid: this.user.userid }).then(response => {
        this.tagaoption = response.data
      }).catch(() => {})
    },
    getData() {
      this.loading = true
      const data = {
        delid: this.user.delid,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.userid,
        search: this.searchForm.search
      }
      getDelVisitorList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    viewRecord(row) {
      console.info(row.userid)
      this.viewData = []
      this.viewVisible = true
      this.dloading = true
      const data = {
        cuserid: row.userid,
        page: 1,
        limit: 99999999
      }
      getBrowsinghistoryList(data).then(response => {
        this.dloading = false
        this.viewData = response.data
      }).catch(() => {
        this.dloading = false
      })
    },
    addToClient(row) {
      this.isdistel = false
      this.infoForm = {
        name: '',
        tel: '',
        weixin: '',
        sex: null,
        city: [],
        address: '',
        style: '',
        area: '',
        labels: [],
        groupid: null,
        remark: '',
        gototime: '',
        isgoto: null
      }
      this.infoForm.name = row.name
      this.infoForm.tel = row.tel
      if (row.tel !== null && row.tel !== '' && row.tel !== undefined) {
        this.isdistel = true
      }
      this.infoForm.sex = row.sex === '男' ? 1 : row.sex === '女' ? 0 : 2
      this.infoForm.city = []
      if (row.province !== null && row.province !== '' && row.province !== undefined) {
        this.infoForm.city.push(row.province)
      }
      if (row.city !== null && row.city !== '' && row.city !== undefined) {
        this.infoForm.city.push(row.city)
      }
      if (row.county !== null && row.county !== '' && row.county !== undefined) {
        this.infoForm.city.push(row.county)
      }
      this.dialogVisible = true
    },
    subClientInfo() {
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            let province = ''
            let city = ''
            let county = ''
            if (this.infoForm.city.length > 0) {
              province = this.infoForm.city[0]
            }
            if (this.infoForm.city.length > 1) {
              city = this.infoForm.city[1]
            }
            if (this.infoForm.city.length > 2) {
              county = this.infoForm.city[2]
            }
            const data = {
              cid: 0,
              name: this.infoForm.name,
              tel: this.infoForm.tel,
              wchat: this.infoForm.weixin,
              sex: this.infoForm.sex,
              province: province,
              city: city,
              county: county,
              address: this.infoForm.address,
              area: this.infoForm.area,
              style: this.infoForm.style,
              groupid: this.infoForm.groupid,
              remark: this.infoForm.remark,
              delid: this.user.delid,
              label: this.infoForm.labels.join(','),
              userid: this.user.userid,
              isgoto: this.infoForm.isgoto,
              gototime: this.infoForm.gototime
            }
            editDelClientInfo(data).then(response => {
              this.$message({
                message: '客户信息添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    addTags() {
      this.$prompt('请输入标签名称', '添加标签', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '标签名称不可为空'
      }).then(({ value }) => {
        editDelClientTag({ userid: this.user.userid, tagid: 0, name: value }).then(response => {
          this.getDelClientTagList()
        }).catch(() => {})
      }).catch(() => {})
    },
    delTags(tagid) {
      this.$confirm('此操作将永久删除此标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delDelClientTag({ tagid: tagid }).then(response => {
          this.infoForm.labels = []
          this.getDelClientTagList()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.fklb-container{
  .tags-container{
    width: 100%;
    position: relative;
    padding: 20px;
    .tags-item{
      position: relative;
      padding: 9px 15px;
      background: #FFF;
      border: 1px dashed #DCDFE6;
      border-radius: 4px;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      font-weight: 500;
      margin:0 20px 20px 0;
      .tags-del{
        padding: 2px!important;
        font-size: 10px!important;
        position: absolute;
        right: -10px;
        top: -6px;
      }
    }
  }
}
</style>
